module.exports = __webpack_public_path__ + "img/instagram.31bb9c54.svg";